import React from "react"
import { Col } from 'react-bootstrap';
import "./loader.css"

const Loader = props => {
  return (
    <Col className="col-12" style={{textAlign:"center"}}>
      <div className="table-loader"><div></div><div></div><div></div></div>
    </Col>
  )
}

export default Loader
